import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useBooking } from "@/context/BookingContext";
import { formatPrice, formatDuration } from "@/lib/format";

export function bookingSuggestions(services, rules, cart) {
    const selected = new Set(cart.map((c) => c.service.id));
    return services.filter((s) => {
        const r = rules[String(s.id)] || {};
        if (selected.has(s.id) || (s.status && s.status !== "visible")) return false;
        if (cart.some((c) => r.incompatible?.includes(c.service.id) || rules[String(c.service.id)]?.incompatible?.includes(s.id))) return false;
        if (r.type === "addon") return r.requires?.some((id) => selected.has(id));
        // "Alongside" is a pairing: staff can configure it from either service.
        // Add-on eligibility above stays directional and must never be bypassed.
        return r.recommended_with?.some((id) => selected.has(id)) ||
            cart.some((c) => rules[String(c.service.id)]?.recommended_with?.includes(s.id));
    });
}

export function BookingSuggestions({ showBasketSummary = false }) {
    const { cart, setCart, goTo } = useBooking();
    const [catalogue, setCatalogue] = useState(null);
    useEffect(() => {
        let active = true;
        api.catalogue().then((data) => { if (active) setCatalogue(data); }).catch(() => {});
        return () => { active = false; };
    }, []);
    if (!cart.length || !catalogue?.multi_checkout_enabled) return null;
    const rules = catalogue.rules || {};
    const suggestions = bookingSuggestions(catalogue.services, rules, cart);
    return <>{showBasketSummary && <div className="rounded-2xl border border-gold/40 p-4 mb-5 text-white"><p className="font-semibold">Your treatments</p><ul className="text-sm space-y-2 mt-2">{cart.map((c) => <li key={c.service.id}>{c.service.name} × {c.quantity}</li>)}</ul><button type="button" className="min-h-11 text-gold underline" onClick={() => goTo("service")}>Back to your treatments</button></div>}{["addon", "main"].map((type) => {
        const items = suggestions.filter((s) => (rules[String(s.id)]?.type || "main") === type);
        if (!items.length) return null;
        return <section key={type} aria-label={type === "addon" ? "Available extras" : "Recommended treatments"} className="rounded-2xl border border-gold/40 p-4 mb-5 text-white">
            <h2 className="font-serif text-xl text-gold">{type === "addon" ? "Extras for your treatments" : "You may also like"}</h2>
            <p className="text-xs text-white/60 mt-1 mb-2">Optional additions to your current booking.</p>
            {items.map((s) => <div key={s.id} className="flex items-center justify-between gap-3 py-3 border-t border-white/10">
                <div className="min-w-0"><p className="text-sm">{s.name}{rules[String(s.id)]?.option_label ? ` · ${rules[String(s.id)].option_label}` : ""}</p><p className="text-xs text-white/60 mt-1">{formatPrice(s.price)} · {formatDuration(s.duration)}</p></div>
                <button type="button" aria-label={`Add ${s.name}`} className="shrink-0 min-h-11 px-4 rounded-full border border-gold text-gold text-sm" onClick={() => setCart([...cart, {service:s, quantity:rules[String(s.id)]?.quantity_min || 1}])}>Add</button>
            </div>)}
        </section>;
    })}</>;
}
